module.exports = __webpack_public_path__ + "img/02-2.0fb7ae15.png";